/*
 * @Author: chengfei
 * @Date: 2022-11-25 17:44:56
 * @LastEditTime: 2025-05-28 14:04:25
 * @LastEditors: yeyimei
 * @Description: 特惠商城相关API
 * @FilePath: \cardlan-h5-qrcode\src\router\mall.routes.js
 */

import classifyPage from '@/views/preferential-mall/classify.vue'
export default [
  // {
  //   path: "/mall",
  //   name: "mall",
  //   component: () =>
  //     import(
  //       /*webpackChunkName: 'home'*/ "@/views/preferential-mall/components/parentCpn/index.vue"
  //     ),
  //   redirect: "/mall/home",
  //   meta: {
  //     activeName: "mall",
  //   },
  //   children: [
  //     {
  //       path: "home",
  //       name: "mallHome",
  //       component: () =>
  //         import(
  //           /*webpackChunkName: 'home'*/ "@/views/preferential-mall/home.vue"
  //         ),
  //       meta: {
  //         title: "9.9元起包邮",
  //         showName: true,
  //         keepAlive: true,
  //         activeName: "mall",
  //       },
  //     },
  //     {
  //       path: "classify",
  //       name: "mallClassify",
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "classify" */ "@/views/preferential-mall/classify.vue"
  //         ),
  //       // component: classifyPage,
  //       meta: {
  //         title: "商城分类",
  //         keepAlive: true,
  //         activeName: "mall",
  //       },
  //     },
  //     {
  //       path: "order-list",
  //       name: "mallOrderList",
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "order-list" */
  //           "@/views/preferential-mall/mall-order.vue"
  //         ),
  //       meta: {
  //         title: "订单",
  //         keepAlive: true,
  //         activeName: "mall",
  //       },
  //     },
  //     {
  //       path: "mine",
  //       name: "mallMine",
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "mine" */
  //           "@/views/mine/index.vue"
  //         ),
  //       meta: {
  //         title: "我的",
  //         keepAlive: true,
  //         activeName: "mall",
  //       },
  //     },
  //   ],
  // },

  {
    path: '/mall/home',
    name: 'mallHome',
    component: () =>
      import(/*webpackChunkName: 'home'*/ '@/views/preferential-mall/home.vue'),
    meta: {
      title: '邦客惠会员商城',
      // title: '9.9元起包邮',
      showName: true,
      keepAlive: true,
      isMallTabBar: true,
    },
  },
  {
    path: '/mall/classify',
    name: 'mallClassify',
    component: () =>
      import(
        /* webpackChunkName: "classify" */ '@/views/preferential-mall/classify.vue'
      ),
    // component: classifyPage,
    meta: {
      title: '商城分类',
      keepAlive: true,
      isMallTabBar: true,
    },
  },
  {
    path: '/mall/order-list',
    name: 'mallOrderList',
    component: () =>
      import(
        /* webpackChunkName: "order-list" */
        '@/views/preferential-mall/mall-order.vue'
      ),
    meta: {
      title: '订单',
      keepAlive: true,
      isMallTabBar: true,
    },
  },
  {
    path: '/mall/mine',
    name: 'mallMine',
    component: () =>
      import(
        /* webpackChunkName: "mine" */
        '@/views/mine/index.vue'
      ),
    meta: {
      title: '我的',
      keepAlive: true,
      isMallTabBar: true,
    },
  },

  {
    path: '/mall/goods-detail',
    name: 'GoodsDetail',
    component: () => import('@/views/preferential-mall/goods-detail.vue'),
    meta: {
      title: '商品详情',
      showName: true,
    },
  },

  {
    path: '/mall/mine-mall-list',
    name: 'mineOrderList',
    component: () => import('@/views/preferential-mall/mine-mall-order.vue'),
    meta: {
      title: '我的订单',
    },
  },
  {
    path: '/mall/order-detail',
    name: 'mallOrderDetail',
    component: () => import('@/views/preferential-mall/order-detail.vue'),
    meta: {
      title: '订单详情',
    },
  },
  {
    path: '/mall/address-list',
    name: 'MallAddressList',
    component: () => import('@/views/preferential-mall/address-list.vue'),
    meta: {
      title: '收货地址',
    },
  },
  {
    path: '/mall/add-address',
    name: 'MallAddAddress',
    component: () => import('@/views/preferential-mall/add-address.vue'),
    meta: {
      title: '编辑收货地址',
    },
  },
  {
    path: '/mall/after-sales',
    name: 'mallAfterSales',
    component: () => import('@/views/preferential-mall/after-sales.vue'),
    meta: {
      title: '订单售后',
    },
  },
  {
    path: '/mall/sales-info',
    name: 'mallSalesInfo',
    component: () => import('@/views/preferential-mall/sales-info.vue'),
    meta: {
      title: '订单售后',
    },
  },
  {
    path: '/mall/express-info',
    name: 'mallExpressInfo',
    component: () => import('@/views/preferential-mall/express-info.vue'),
    meta: {
      title: '订单售后',
    },
  },
  {
    path: '/mall/standard',
    name: 'mallStandard',
    component: () => import('@/views/preferential-mall/standard.vue'),
    meta: {
      title: '规则详情',
    },
  },
  {
    path: '/mall/notice-list',
    name: 'mallNoticeList',
    component: () => import('@/views/preferential-mall/notice-list.vue'),
    meta: {
      title: '系统公告',
    },
  },
  {
    path: '/mall/notice',
    name: 'mallNotice',
    component: () => import('@/views/preferential-mall/notice.vue'),
    meta: {
      title: '公告详情',
    },
  },
]
